// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_by-b";
export var colorBlue = "_by-8";
export var colorDot = "_by-0";
export var colorDotLarge = "_by-2";
export var colorDotSmall = "_by-1";
export var colorGreen = "_by-7";
export var colorGrey = "_by-3";
export var colorOrange = "_by-5";
export var colorPink = "_by-a";
export var colorPurple = "_by-9";
export var colorRed = "_by-4";
export var colorYellow = "_by-6";